import { retrieveItem } from "@src/helpers/functions";

export const useCheckPageComponentAccess = (key: string) => {
  let hasAccess: boolean | null = null;
  const pageComponentAccesses =
    retrieveItem("page_component_accesses") ??
    retrieveItem("pageComponentAccesses") ??
    [];
  try {
    let pageComponentAccess = pageComponentAccesses.find(
      (x: string) => x === key
    );

    if (pageComponentAccess) {
      hasAccess = true;
    } else {
      hasAccess = false;
    }
  } catch (e) {
    hasAccess = false;
  }
  return hasAccess;
};